import React from 'react'
import './Header.css';

const Header = () => {
    return (
        <div className= "header-faltas">
            <div className= "titulo-faltas">
                <h2>
                    Faltas (Materias Oficiales)
                </h2>
            </div>
        </div>      
    );
};

export default Header;